import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'
import RadialProgress from '../../../generic/RadialProgress'
import keyUpHandler from '../../../utils/keyUpHandler'
import './styles.css'

class LearningPathCourse extends Component {
  static getCategoryIconName(category) {
    return category
      .replace('&', '')
      .replace(',', '')
      .replace(/\s+/g, '-')
      .toLowerCase()
  }

  constructor(props) {
    super(props)
    this.state = { visible: false, cta: 'preview course' }
    this.getChapters = this.getChapters.bind(this)
    this.checkCompletedChapters = this.checkCompletedChapters.bind(this)
    this.isFiltered = this.isFiltered.bind(this)
    this.loadCourse = this.loadCourse.bind(this)
    this.setViewCourse = this.setViewCourse.bind(this)
    this.checkOverallProgress = this.checkOverallProgress.bind(this)
    this.toggle = this.toggle.bind(this)
    this.loadChapter = this.loadChapter.bind(this)
  }

  componentDidMount() {
    this.setViewCourse()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isEnrolled !== this.props.isEnrolled) this.setViewCourse()
  }

  getChapters() {
    const { relevantChapters, chapters } = this.props
    if (relevantChapters && relevantChapters.length > 0) return relevantChapters
    return chapters
  }

  isFiltered(course) {
    return this.props.filter.length === 0 || this.props.filter.includes(course)
  }

  checkCompletedChapters() {
    const { relevantChapters, chapters } = this.props
    if (relevantChapters && relevantChapters.length > 0) {
      const ids = relevantChapters.map((chapter) => chapter.id)
      return _.size(
        chapters.filter(
          (chapter) => ids.includes(chapter.id) && chapter.isComplete === true
        )
      )
    }
    return _.size(_.filter(chapters, { isComplete: true }))
  }

  checkChapter(chapter) {
    const { chapters, relevantChapters } = this.props
    const chapterFound = chapters.find((chap) => chap.id === chapter.id)
    if (relevantChapters && relevantChapters.length > 0)
      return !chapterFound.isComplete
    return !chapter.isComplete
  }

  checkOverallProgress() {
    const { relevantChapters, overallProgress } = this.props
    if (relevantChapters) {
      const completedChapters = this.checkCompletedChapters()
      if (relevantChapters.length === 0 && this.props.chapters.length > 0)
        return (completedChapters / this.props.chapters.length) * 100
      return (completedChapters / relevantChapters.length) * 100
    }
    return overallProgress
  }

  loadCourse(tutorial) {
    const {
      openPreview,
      isEnrolled,
      loadLearningPathwayCourse,
      slug,
      id
    } = this.props
    if (isEnrolled) loadLearningPathwayCourse(null, slug, id)
    else openPreview(tutorial)
  }

  setViewCourse() {
    const { overallProgress, isEnrolled } = this.props
    const progress = parseInt(overallProgress, 10)
    if (isEnrolled)
      if (progress < 100 && progress > 0)
        this.setState({ cta: 'continue course' })
      else if (progress >= 100) this.setState({ cta: 'rewatch course' })
      else this.setState({ cta: 'start course' })
    else this.setState({ cta: 'preview course' })
  }

  toggle() {
    this.setState({ visible: !this.state.visible })
  }

  loadChapter(chapter) {
    const { loadLearningPathwayCourse, slug, id } = this.props
    const chapterToLoad = {
      chapterOrder: chapter.order,
      time: 0
    }
    loadLearningPathwayCourse(chapterToLoad, slug, id)
  }

  render() {
    const {
      title,
      description,
      photo,
      artist,
      difficulty,
      durationH,
      durationM,
      isEnrolled,
      isBasicSubscriber,
      learningPath,
      pathId,
      slug,
      category,
      overallProgress,
      trailer,
      owned
    } = this.props

    const chaptersAmount = _.size(this.getChapters())
    const pctgWatched = isEnrolled ? this.checkOverallProgress() : 0

    if (chaptersAmount <= 0 || !this.isFiltered(category)) return null

    return (
      <div className="learning-path-course">
        <Link
          aria-label={title}
          to={`/tutorials/${slug}?watch=${isBasicSubscriber ? 0 : 1}&path=${learningPath}&path_id=${pathId}`}
        >
          {_.has(this.props, 'photo.default') && (
            <div className="image-container">
              <div className="overlay" />
              <div style={{ backgroundImage: `url(${photo.boxThumbSm})` }} className="image" />
              <div className={classnames('progress', { completed: pctgWatched === 100 })}>
                <RadialProgress percentage={pctgWatched} sqSize={128}>
                  <i className={`icon-${LearningPathCourse.getCategoryIconName(category)}`} />
                </RadialProgress>
                {owned && <span>{parseInt(pctgWatched, 10)}%</span>}
              </div>
            </div>
          )}
        </Link>
        <div className="body">
          <h3 className="title">
            <Link to={`/tutorials/${slug}?watch=${isBasicSubscriber ? 0 : 1}&path=${learningPath}&path_id=${pathId}`}>
              {title}
            </Link>
          </h3>
          <div className="small-wrapper">
            <div className="course-description">
              <p>
                {description}
                <Link to={`/tutorials/${slug}?path=${learningPath}&path_id=${pathId}`}>See more.</Link>
              </p>
            </div>
            {_.has(this.props, 'trailer') && !_.isEmpty(trailer) && (
              <div className="preview-course">
                <button type="button" onClick={() => this.loadCourse(this.props)}>
                  {this.state.cta}
                </button>
              </div>
            )}
            {_.has(this.props, 'artist.title') && _.has(this.props, 'artist.slug') && (
              <div className="author">
                <i className="icon-account" />
                <span><Link to={`/artists/${artist.slug}`}>{artist.title}</Link></span>
              </div>
            )}
            <div className="level">
              <i className={`icon-level${difficulty}`} />
              {difficulty === 1 && <span>Beginner Level</span>}
              {difficulty === 2 && <span>Intermediate Level</span>}
              {difficulty === 3 && <span>Advanced Level</span>}
            </div>
            <div className="duration">
              <i className="fa-clock" />
              {durationH > 0 && <span>{durationH}h </span>}
              <span>{durationM}m</span>
              {' '}of duration
            </div>
            {isEnrolled && (
              <>
                <div
                  aria-label="See chapter list"
                  className="completion"
                  onClick={() => this.toggle()}
                  onKeyUp={(event) => keyUpHandler(event, this.toggle, null, this)}
                  tabIndex={0}
                  role="button"
                >
                  <i className="icon-stream" />
                  <div className="text">
                    <span>{`${this.checkCompletedChapters()} chapters completed`}</span>
                    <i className={classnames('icon-right-2', { animate: this.state.visible })} />
                  </div>
                  {parseInt(overallProgress, 10) === 100 && (
                    <div className="cleared">
                      <span>cleared</span>
                      <div className="check-circle"><i className="icon-checkmark" /></div>
                    </div>
                  )}
                </div>
                {this.state.visible && (
                  <div className="chapters">
                    {this.getChapters().map((chapter, index) => (
                      <div
                        aria-label={`Watch chapter ${chapter.title}`}
                        className="chapter"
                        key={index}
                        onClick={() => this.loadChapter(chapter)}
                        onKeyUp={(event) => keyUpHandler(event, this.loadChapter, null, this, [chapter])}
                        tabIndex={0}
                        role="button"
                      >
                        <div className="title">{chapter.title}</div>
                        <div className={classnames('check-circle', { unchecked: this.checkChapter(chapter) })}>
                          <i className="icon-checkmark" />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    )
  }
}

LearningPathCourse.propTypes = {
  category: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  durationH: PropTypes.number.isRequired,
  durationM: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  loadBookmark: PropTypes.func,
  openPreview: PropTypes.func.isRequired,
  overallProgress: PropTypes.number,
  photo: PropTypes.shape({
    bookmarkThumb: PropTypes.string,
    boxThumb: PropTypes.string.isRequired,
    boxThumbSm: PropTypes.string.isRequired,
    cartThumb: PropTypes.string,
    galleryThumb: PropTypes.string,
    medium: PropTypes.string,
    original: PropTypes.string,
    thumb: PropTypes.string,
    default: PropTypes.string
  }).isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  chapters: PropTypes.array,
  relevantChapters: PropTypes.array,
  filter: PropTypes.array,
  isEnrolled: PropTypes.bool,
  isBasicSubscriber: PropTypes.bool,
  learningPath: PropTypes.string,
  pathId: PropTypes.number,
  loadLearningPathwayCourse: PropTypes.func,
  artist: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string
  }),
  difficulty: PropTypes.number,
  trailer: PropTypes.string,
  owned: PropTypes.bool
}

LearningPathCourse.defaultProps = {
  overallProgress: null,
  loadBookmark: () => {},
  url: '',
  chapters: [],
  relevantChapters: [],
  filter: [],
  isEnrolled: false,
  isBasicSubscriber: false,
  learningPath: '',
  pathId: null,
  loadLearningPathwayCourse: () => {},
  artist: null,
  difficulty: 1,
  trailer: '',
  owned: false
}

export default LearningPathCourse
